/* eslint-disable react/no-danger */
import { AboutStyles } from '@/components/About/AboutStyles';
import { VideoModalStyles } from '@/components/VideoModal/VideoModalStyles';
import clickOutside from '@/helpers/clickOutside';
import useMediaQuery from '@/helpers/hooks/useMediaQuery.js';
import FooterComponent from '@components/Footer/FooterComponent';
import Header from '@components/Header/Header';
import SEOHead from '@components/SEOHead/SEOHead';
import VsTraditionalComponent from '@components/VsTraditional/VsTraditionalComponent';
import validatePaidCampaign from '@helpers/validatePaidCampaign';
import fetch from 'isomorphic-unfetch';
import Image from 'next/future/image';
import React, { useRef, useState } from 'react';
import sanitizeHtml from 'sanitize-html';
import { WordPressAPI } from '../config';
import dynamic from 'next/dynamic';

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const About = ({ data }) => {
  const { acf, title } = data;
  const page_title_tag = acf.page_title_tag
  const sanitizeSettings = {
    allowedTags: ['p', 'h2'],
    allowedClasses: {
      'p': ['hero-title', 'about-services-subtitle']
    },
  };
  const [videoIsOpen, setVideoIsOpen] = useState(false);
  const ref = useRef();

  const { phone_number_setup } = acf;
  const paid_campaign = validatePaidCampaign(acf.paid_campaign);
  const { meta_description, additional_questions } = acf;
  console.log(acf)
  const about_services_title_1 = acf.about_services[0].title.slice(0, 22);
  const about_services_title_2 = acf.about_services[0].title.slice(23);
  const isMobile = useMediaQuery('(max-width: 1000px)');
  // if click outside of video, close modal
  clickOutside(ref, () => {
    if (videoIsOpen) {
      setVideoIsOpen(false);
    }
  });

  const openVideo = () => {
    setVideoIsOpen(true);
  }

  return (
    <AboutStyles>
      <SEOHead>
        <title>{page_title_tag}</title>
        <meta name="description" content={meta_description} key="description" />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
      </SEOHead>
      <Header
        AdditionalQuestions={additional_questions}
        PaidCampaign={paid_campaign}
        phone_number={phone_number_setup}
        leadValues={acf.lead_values}
      />
      <section className="about-hero">
        <div className="container">
          <div className="hero-text-container">
            <div
              className="hero-title"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(acf.about_hero_title, sanitizeSettings),
              }}
            />
            <div className="hero-image-container">
              <img
                className="hero-image"
                src={acf.about_hero_image.url}
                alt="about logo"
                width="500px" height="500px"
              />
            </div>
            <div className="hero-text">{acf.about_hero_text}</div>
            <img
              className="hero-thumbnail-small"
              src={acf.about_hero_video_thumbnail.url}
              alt="video thumbnail"
              width="500px" height="500px"
              onClick={openVideo}
            />
            <div className="hero-subtext">{acf.about_hero_subtext}</div>
          </div>
          <div className="hero-thumbnail-container">
            <img
              className="hero-thumbnail-large"
              src={acf.about_hero_video_thumbnail.url}
              alt="video thumbnail"
              width="500px" height="500px"
              onClick={openVideo}
            />
          </div>
        </div>
      </section>

      <section className="business-needs">
        <div className="container">
          {acf.business_needs.map((item, index) => (
            <img className="business-need-image" src={item.icon.url} alt="business needs image" width="500px" height="500px" />
          ))}
        </div>
      </section>

      <section className="about-services">
        <div className="container">
          <div className="about-services-image-container">
            <Image
              className="about-services-image"
              src={acf.about_services[0].image}
              alt="about services image"
              width={1200}
              height={600}
              layout="raw"
            />
          </div>
          <div className="about-services-text-container">
            <div className="about-services-title">
              {about_services_title_1}
            </div>
            <div className="about-services-title">
              {about_services_title_2}
            </div>
            <div
              className="about-services-subtitle"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(acf.about_services[0].subtitle, sanitizeSettings),
              }}
            />
          </div>
        </div>
      </section>
      {isMobile && <div className='container title-group'>
        <span className="title-us">
          <Image
            className="about-services-image"
            src='/images/1800logo.png'
            alt="1800accountant logo image"
            width={1200}
            height={600}
            layout="raw"
          />
        </span>
        <span className="title-vs">
          {acf.vs_traditional_title.slice(16, 18)}
        </span>
        <span className="title-them">
          {acf.vs_traditional_title.slice(19)}
        </span>
      </div>}

      <VsTraditionalComponent
        title={acf.vs_traditional_title}
        us={acf.vs_traditional_us}
        themTitle={acf.vs_traditional_them_title}
        them={acf.vs_traditional_them}
        secondaryContent={acf.vs_traditional_secondary_content}
        acf={acf}
        isMobile={isMobile}
      />

      <section className="testimonial">
        <div className="container">
          <div className="testimonial-image-container">
            <Image className="testimonial-image" src={acf.testimonial.image} alt="CEO Testimonial Image"
                    layout="raw" width={600} height={600}/>
          </div>
          <div className="testimonial-text-container">
            <div className="testimonial-quote">
              {acf.testimonial.quote}
            </div>
            <div className="testimonial-attribution">
              {acf.testimonial.attribution}
            </div>
          </div>
        </div>
      </section>
      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={phone_number_setup} />
      {videoIsOpen && (
        <VideoModalStyles>
          <div
            className="modal video-modal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="myLargeModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content" ref={ref}>
                <div className="modal-body">
                  <div className="embed-responsive embed-responsive-16by9">
                    <video
                      playsInline
                      muted
                      video="true"
                      autoPlay
                      controls
                      loop
                      className="bg-video"
                      height="auto"
                      width="85%"
                    >
                      <source
                        src={acf.about_hero_video.url}
                        type="video/mp4"
                      />
                      <track
                        kind="captions"
                        src="/static/about_captions.vtt"
                        srcLang="en"
                        label="English"
                        default
                      />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VideoModalStyles>
      )}
    </AboutStyles>
  );
}

export const getStaticProps = async () => {
  const pagesRes = await fetch(`${WordPressAPI.pages}/17213`);
  const data = await pagesRes.json();

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

export default About;
